import { render, staticRenderFns } from "./ChatSimulator.vue?vue&type=template&id=ae2a8dfe&scoped=true&"
import script from "./ChatSimulator.vue?vue&type=script&lang=js&"
export * from "./ChatSimulator.vue?vue&type=script&lang=js&"
import style0 from "./ChatSimulator.vue?vue&type=style&index=0&id=ae2a8dfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae2a8dfe",
  null
  
)

export default component.exports